import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchGetFormalOffers } from '@iwoca/lapi-client/edge';
import { Link, Modal } from '@iwoca/orion';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage, useIntl } from 'react-intl';

import messages from './PriceCheckBanner.messages';
import { PriceCheckModalContentDE } from './PriceCheckModalContentDE';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const PriceCheckBanner = () => {
    const intl = useIntl();
    const stateKey = useStateKey();

    const { data: formalOfferIds } = useQuery({
        queryKey: ['formal_offers', stateKey],
        queryFn: () => fetchGetFormalOffers({ stateKey }),
        select: (data) => {
            const formalOfferIds = [];
            for (const offer of data.data.formal_offers) {
                formalOfferIds.push(offer.offer_id!);
            }
            return formalOfferIds;
        }
    });

    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <div className="mb-m bg-primary-20 py-xs text-center font-reg text-structure-95">
                <FormattedMessage
                    {...messages.priceCheckMessage}
                    values={{
                        strong: (chunks) => <strong>{chunks}</strong>
                    }}
                />{' '}
                <Link
                    className="font-reg text-structure-95 underline"
                    onClick={() => {
                        setIsModalOpen(true);
                        tracking.ampli.priceCheckBannerLearnMoreClicked({
                            offer_ids: formalOfferIds!
                        });
                        tracking.ampli.priceCheckModalOpened();
                    }}
                >
                    <FormattedMessage {...messages.priceCheckCTA} />
                </Link>
            </div>

            <Modal
                size="large"
                headerBar
                closeIcon
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    tracking.ampli.priceCheckModalClosed();
                }}
                title={intl.formatMessage(messages.modalTitle)}
                subTitle={intl.formatMessage(messages.modalSubtitle)}
                className="z-100 absolute"
            >
                <div className="flex flex-col items-center justify-center text-center">
                    <PriceCheckModalContentDE />
                </div>
            </Modal>
        </>
    );
};
